import { tenantConfig } from '../api/config';
import { apiLaunchAppUrl } from '../auth/azure-ad-b2c'

export const getTenant = async () => {
   try {
      const response = await fetch(apiLaunchAppUrl, { referrerPolicy: "unsafe-url" });

      let tenant = {};

      if (response.ok) {
         let res = await response.json();
         tenant = {
            id: res['id'] ?? tenantConfig['id'],
            identifier: res['identifier'] ?? tenantConfig['identifier'],
            name: res['name'] ?? tenantConfig['name'],
            connectionString: res['connectionString'] ?? tenantConfig['connectionString'],
            metadataAddress: res['metadataAddress'] ?? tenantConfig['metadataAddress'],
            audience: res['audience'] ?? tenantConfig['audience'],
            authority: res['authority'] ?? tenantConfig['authority'],
            launchURL: res['launchURL'] ?? tenantConfig['launchURL'],
            uiClientId: res['uiClientId'] ?? tenantConfig['uiClientId']
         }
      }

      if (!tenant) throw new Error("Could not identify tenant, please make sure url is correct.");
      return tenant;
   }
   catch (err) {
      console.error(err);
      throw new Error("An error occurred while identifying tenant.");
   }
}